module.exports = __webpack_public_path__ + "static/media/cooperation1.151787d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/cooperation1.jpg
// module id = 208
// module chunks = 6